import { render, staticRenderFns } from "./Waste_lifting_list.vue?vue&type=template&id=4d8bf44c&"
import script from "./Waste_lifting_list.vue?vue&type=script&lang=js&"
export * from "./Waste_lifting_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports